/**
 * Находит пересечение двух массивов без дубликатов.
 *
 * @param first Первый массив
 * @param second Второй массив
 * @typeParam T Тип элементов в массиве
 * @returns Пересечение двух массивов
 *
 * @example
 * ```typescript
 * import { intersection } from '@direct-frontend/stdlib';
 *
 * intersection([1, 2, 3, 4, 5], [2, 3, 7, 8]); // [2, 3]
 * ```
 */
export function intersection(first, second) {
    const setFirst = new Set(first);
    const setSecond = new Set(second);
    const intersection = new Set([...setFirst].filter(x => setSecond.has(x)));
    return Array.from(intersection);
}
